import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-temperature',
  templateUrl: './temperature.component.html',
  styleUrls: ['./temperature.component.css']
})
export class TemperatureComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit() {
  }

  public back() {
    this.location.back();
  }
}
